import { KeyGroup } from '@libs/types/enum'
import { DevicePid } from './define'
import { JingTaiMer68Devices, JingTaiMg75Devices } from './device_vendor'
import { HuoChaiRenDevices } from '@hid/define/define'

export const DevicesSwitchOfTianqing = [DevicePid.IROKNd63_cyan, DevicePid.IYXMu68Pro_cyan, DevicePid.IROKMg68, DevicePid.IROKMg68SE, DevicePid.IROKMg68LITE]
export const DevicesSwitchOfTianqing_Pro = [...HuoChaiRenDevices]

export const DevicesSwitchOfZixin = [
  DevicePid.IYXMu68_ULTRA,

  DevicePid.CarotmasMars68,
  DevicePid.CarotmasMars68_Wireless,
  DevicePid.CarotmasMars68_Wireless_24g,

  DevicePid.CarotmasMars68SE,

  DevicePid.CarotmasMars68Pro,
  DevicePid.CarotmasMars68Pro_Wireless,
  DevicePid.CarotmasMars68Pro_Wireless_24g,

  DevicePid.IROKMg68Max,
  DevicePid.IROKMg68Max_24g,
  DevicePid.IROKMg68Pro,
  DevicePid.IROKMG68ACE,
  DevicePid.IROKMG68ACE_W,
  DevicePid.IROKMG68ACE_W_24g,
  DevicePid.IROKMG68ACE_UpPlus,

  // ...Mg75Devices,
  // ...Mer68Devices
  DevicePid.IROKND63Max,
  DevicePid.CarotmasMer68Max,

  DevicePid.CarotmasMars75,
  DevicePid.CarotmasMars75Pro,
  DevicePid.IROKND68Pro,
  DevicePid.IROKND63Ultra,

  DevicePid.IROKND68,
  DevicePid.IROKND63Max,
]

export const DevicesSwitchOfWanciwang = [
  // DevicePid.IYXPolar75,
]

export const DevicesSwitchOfXingguang = [DevicePid.IROKMg68Plus]

export const DevicesSwitchOfQinghui = [DevicePid.IROKMg75Max, DevicePid.IROKRA68]

export const DevicesSwitchOfDefault = [DevicePid.IROKNa87Pro, DevicePid.IYXMu68Pro, DevicePid.IROKNd63]
// 无法确定的轴体，多种轴体 - 默认轴体
export const DevicesSwitchOfUnknown = [DevicePid.IYXPolar75, ...JingTaiMg75Devices, ...JingTaiMer68Devices]

const defaultAxis = KeyGroup.cipo
const deviceAxis: Map<DevicePid, KeyGroup> = new Map()
DevicesSwitchOfTianqing.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.tianqing))
DevicesSwitchOfDefault.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.cipo))
DevicesSwitchOfZixin.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.zixing))
DevicesSwitchOfWanciwang.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.wanciwang))
DevicesSwitchOfXingguang.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.xingguang))
DevicesSwitchOfQinghui.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.qinghui))
DevicesSwitchOfUnknown.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.unknown))
DevicesSwitchOfTianqing_Pro.forEach((devicePid: DevicePid) => deviceAxis.set(devicePid, KeyGroup.qinghui_pro))

export const getCurrentDeviceAxis = (keyGroup: DevicePid): KeyGroup => {
  return deviceAxis.get(keyGroup) || defaultAxis
}
